import { BaseModel } from "sjs-base-model";
export default class TaskModel extends BaseModel {
    id = 0;
    recur = "";
    state = "";
    orderItemId = 0;
    product =""
    startTime = "";
    finishTime = "";
    cmd = "";
    from = "";
    to = "";
    description = "";
    remark = "";
    productFolder = "";
    subscriptionType = "";
    subscription = 0;
    orderId = 0;
    forceExecute = 0;
    constructor(data) {
        super();
        this.update(data);
    }
}
